import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { InvoiceListStatusCell } from './invoice-list-status.cell';
import { InvoiceListStatusHeader } from './invoice-list-status.header';

export const InvoiceListStatusColumn: IdentifiedColumnDef<
  InvoiceModel,
  InvoiceModel['status']
> = {
  enableSorting: false,
  header: InvoiceListStatusHeader,
  cell: InvoiceListStatusCell,
  meta: { width: '200px' },
};
